import React from 'react';
import { Icon } from '@iconify/react';
import { useSetting } from '../utils/AppSettingsContext';

const PartsDataTable = ({
  parts,
  onEdit,
  onDelete,
  loading,
  useModule,
  sortField,
  sortOrder,
  onSort,
}) => {
  const weightUom = useSetting('weight_uom');
  const useRotables = useModule('rotables');

  const getSortIcon = (field) => {
    if (sortField !== field || !sortOrder) {
      return 'mdi:sort';
    }
    return sortOrder === 'asc' ? 'mdi:sort-ascending' : 'mdi:sort-descending';
  };

  const renderSortableHeader = (label, field) => {
    const ariaSort = sortField === field
      ? sortOrder === 'asc'
        ? 'ascending'
        : sortOrder === 'desc'
          ? 'descending'
          : 'none'
      : 'none';

    return (
      <th
        onClick={() => onSort?.(field)}
        style={{ cursor: 'pointer' }}
        scope="col"
        aria-sort={ariaSort}
      >
        <span className="d-inline-flex align-items-center gap-1">
          {label}
          <Icon className="text-xl" icon={getSortIcon(field)} />
        </span>
      </th>
    );
  };

  return (
    <table className="table bordered-table mb-3 w-100 rounded-0">
      <thead>
        <tr>
          {renderSortableHeader('Part Number', 'partNumber')}
          {renderSortableHeader('Description', 'description')}
          {renderSortableHeader('Category', 'category')}
          <th>Stock Item</th>
          {useRotables && ('rotables' && <th>Rotable</th>)}
          {renderSortableHeader('Manufacturer', 'manufacturer')}
          <th>Weight ({weightUom})</th>
          <th className="rounded-0">Actions</th>
        </tr>
      </thead>

      <tbody>
        {parts.map((row) => (
          <tr key={row.id}>
            <td>{row.partNumber}</td>
            {/*<td>{row.oemNumber}</td>*/}
            <td>{row.description}</td>
            <td>{row.category?.name || ''}</td>
            <td>
              <div className="form-switch switch-primary d-flex align-items-center gap-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={row.stockedItem === 1}
                  disabled
                />
              </div>
            </td>
            {useRotables && ('rotables' && <td>
              <div className="form-switch switch-primary d-flex align-items-center gap-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={row.rotable === 1}
                  disabled
                />
              </div>
            </td>)}
            <td>{row.sourceOfSupply?.manufacturer || ''}</td>
            <td>{row.weight ?? ''}</td>
            <td>
              <button
                className="edit-btn w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center mx-6"
                onClick={() => onEdit(row)}
              >
                <Icon icon="ic:baseline-edit" />
              </button>
              <button
                className="delete-btn w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                onClick={() => onDelete(row.id)}
              >
                <Icon icon="ic:baseline-delete-outline" />
              </button>
            </td>
          </tr>
        ))}
        {!loading && parts.length === 0 && (
          <tr>
            <td colSpan={9} className="text-center py-2">
              No Parts found
            </td>
          </tr>
        )}
        {loading && (
          <tr>
            <td colSpan={9} className="text-center py-2">
              <span className="spinner-border spinner-border-sm" />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default PartsDataTable;
